import { gsap } from 'gsap/all'
import LazyLoad from 'vanilla-lazyload'

export let lazy

export const initLazy = () => {
  lazy = new LazyLoad({
    elements_selector: '.js-lazy',
    callback_loaded: el => {
      gsap.set(el, { opacity: 1 })
    }
  })
}
